import { atom } from 'recoil';
import {
  getLocalStorageValue,
  LocalStorageKey,
} from '../../utils/localStorage/localStorage';
import { DEFAULT_VALUES } from '../../../config/defaultValues/defaultValues';

export const selectedLanguageState = atom<string>({
  key: 'languageState',
  default:
    getLocalStorageValue(LocalStorageKey.language) ??
    DEFAULT_VALUES.defaultCountry,
});
